// @ts-check
/** Validate the page contract once at mount; render paths use stable references.
 * @param {Document} root
 */
export function getGameElements(root) {
  /** @template {typeof HTMLElement} T @param {string} selector @param {T} constructor @returns {InstanceType<T>} */
  function required(selector, constructor) {
    const node = root.querySelector(selector);
    if (!(node instanceof constructor)) throw new Error(`Missing game element: ${selector}`);
    return /** @type {InstanceType<T>} */ (node);
  }
  /** @param {string} selector */ const element = (selector) => required(selector, HTMLElement);
  /** @param {string} selector */ const canvas = (selector) => required(selector, HTMLCanvasElement);
  /** @param {string} selector */ const image = (selector) => required(selector, HTMLImageElement);
  /** @param {string} selector */ const button = (selector) => required(selector, HTMLButtonElement);
  return {
    uplinkCanvas: canvas('#uplink-fx'), transferCover: element('#sector-transfer'), transferLabel: element('#transfer-label'),
    flow: element('#play-flow'), flowTitle: element('#flow-title'), flowDetail: element('#flow-detail'), flowHelp: element('#flow-help'),
    start: button('#start-run'), pause: button('#pause-run'),
    guide: element('#field-guide'), inventory: element('#inventory'), bits: element('#bit-count'), power: element('#power-status'), reward: element('#reward-status'),
    root, stage: element('#stage'), qp: element('#qp'), pose: element('#qp-pose'), image: image('#qp-pose img'),
    runCanvas: canvas('#qp-run'), poseCanvas: canvas('#qp-static'), background: canvas('#cyberspace'), terrain: canvas('#level-scene'),
    sources: { run: image('#qp-run-source'), original: image('#qp-original-source'), right: image('#qp-right-source'), left: image('#qp-left-source') },
    shadow: element('#shadow'), impulse: element('#impulse'), moveStatus: element('#move-status'), progress: element('#level-progress'),
    result: element('#level-result'), resultTitle: element('#result-title'), resultDetail: element('#result-detail'),
    title: element('#scene-title'), caption: element('#scene-caption'), error: element('#image-error'),
    restart: button('#restart'), restartResult: button('#restart-result'),
    buttons: [...root.querySelectorAll('button[data-action]')].filter((node) => node instanceof HTMLButtonElement),
    modes: [...root.querySelectorAll('button[data-mode]')].filter((node) => node instanceof HTMLButtonElement),
  };
}
/** @typedef {ReturnType<typeof getGameElements>} GameElements */
